module.exports = __webpack_public_path__ + "static/media/switch_logo.e3705925.png";